import type { ReasonsPromotionApi } from './types'

export const toReasonsPromotion = (reasonsPromotionApi: ReasonsPromotionApi) => {
  return {
    description: reasonsPromotionApi.Descricao,
    id: reasonsPromotionApi.Codigo,
    type: reasonsPromotionApi.Tipo,
  }
}

export const toReasonsPromotionData = (response: ReasonsPromotionApi[]) => {
  return response.map((reason) => toReasonsPromotion(reason))
}
